import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/**
 * Emitted when a member finishes the profile-completion wizard and their
 * onboarding moves `in_progress` → `completed` (IMM-271.2). The member is the
 * sole author of their own onboarding, so their member actor rides the payload.
 * Ids + occurredAt only per ADR 0015 §PII — the recorded consent (granted flag,
 * timestamp, grantor e-mail, wording version) is persisted on the record, never
 * on the event. Audited under aggregateType `identity.member-onboarding`.
 */
export const MemberOnboardingCompletedPayloadSchema = z.object({
  onboardingId: z.uuid(),
  memberId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type MemberOnboardingCompletedPayload = z.infer<typeof MemberOnboardingCompletedPayloadSchema>;
